// export function parseDate(dateString:string): Date {
// 	return dateString ? new Date(dateString.split('T')[0]) : null;
// }

// export function convertDateToUTC(date:Date): Date {
// 	return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
// }

// export function formatDate(date:Date): string {
// 	return `${pad(date.getFullYear())}-${pad(date.getMonth()+1)}-${pad(date.getDate())}`;
// }

// export function formatDateDisplay(date:Date): string {
// 	const utcDate = convertDateToUTC(date);
// 	return `${pad(utcDate.getMonth()+1)}-${pad(utcDate.getDate())}-${pad(utcDate.getFullYear())}`;
// }

// function pad(number: number) {
// 	if(number < 10) {
// 		return 0 + number.toString();
// 	}
// 	return number.toString();
// }
export class DateUtils {

  static isValid(date: any): boolean {
    const d = new Date(date);
    return d instanceof Date && !isNaN(d.getTime());
  }

  static parse(date: any): Date {
    return new Date(date);
  }

  static format(dateInput: any, format: string): string {
	const d = new Date(dateInput);

	const map: any = {
		YYYY: d.getFullYear(),
		MM: this.pad(d.getMonth() + 1),
		DD: this.pad(d.getDate()),
		HH: this.pad(d.getHours()),
		mm: this.pad(d.getMinutes()),
		ss: this.pad(d.getSeconds())
	};

	let result = format;

	Object.keys(map).forEach(k => {
		result = result.replace(k, map[k]);
	});

	return result;
	}

  static formatYYYYMMDD(dateInput: any): string {
    const d = new Date(dateInput);

    return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}`;
  }

  static formatDateTime(dateInput: any): string {
    const d = new Date(dateInput);

    return (
      `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}` +
      `T${this.pad(d.getHours())}:${this.pad(d.getMinutes())}:${this.pad(d.getSeconds())}`
    );
  }

  static formatDisplayDate(dateInput: any): string {
    const d = new Date(dateInput);

    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    });
  }

  static addDays(dateInput: any, days: number): Date {
    const d = new Date(dateInput);
    d.setDate(d.getDate() + days);
    return d;
  }

  static addYears(dateInput: any, years: number): Date {
    const d = new Date(dateInput);
    d.setFullYear(d.getFullYear() + years);
    return d;
  }

  static isBefore(a: any, b: any): boolean {
    return new Date(a).getTime() < new Date(b).getTime();
  }

  static isAfter(a: any, b: any): boolean {
    return new Date(a).getTime() > new Date(b).getTime();
  }

  static isSameDay(a: any, b: any): boolean {
    const d1 = new Date(a);
    const d2 = new Date(b);

    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  static startOfDay(dateInput: any): Date {
    const d = new Date(dateInput);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  static endOfDay(dateInput: any): Date {
    const d = new Date(dateInput);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);
  }

  static between(date: any, start: any, end: any): boolean {
    const t = new Date(date).getTime();
    const s = new Date(start).getTime();
    const e = new Date(end).getTime();

    return t >= s && t <= e;
  }

  static min(a: any, b: any): Date {
	const d1 = new Date(a);
	const d2 = new Date(b);
	return d1.getTime() <= d2.getTime() ? d1 : d2;
	}
	
  private static pad(value: number): string {
    return value.toString().padStart(2, '0');
  }
}